import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Modal from 'LuxKit/Modal/Modal'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { defineMessages, useIntl } from 'react-intl'

const messages = defineMessages({
  label: {
    id: 'JL8nNvsB7WnKwzBUMhD6',
    defaultMessage: 'Set your commission',
  },
  modalTitle: {
    id: 'Ec95lq0b5oGaxi2m8woc',
    defaultMessage: 'How flight commission works',
  },
  explanation: {
    id: '4riDig-WI-4oGxItACB_',
    defaultMessage: 'The price shown is the net flight price, with no commission included. You’ll set your commission at checkout and add it to the price you charge your customer. This gives you the flexibility to set a final price that works for you and your customer.',
  },
})

function AgentHubFlightSetCommissionLink() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const label = intl.formatMessage(messages.label)
  const modalTitle = intl.formatMessage(messages.modalTitle)
  const explanation = intl.formatMessage(messages.explanation)

  const openModal = useCallback<MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<Modal title={modalTitle}>
      <VerticalSpacer gap={8}>
        <BodyText variant="large">
          {explanation}
        </BodyText>
      </VerticalSpacer>
    </Modal>)
  }, [explanation, modalTitle, showModal])

  return (
    <Group direction="vertical" gap={4}>
      <Caption variant="medium">
        <TextLink
          colour="highlight-primary-dark"
          endIcon={<LineInfoCircleIcon colour="normal-contrast" />}
          onClick={openModal}
        >
          {label}
        </TextLink>
      </Caption>
    </Group>
  )
}

export default AgentHubFlightSetCommissionLink
